var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "grey lighten-4", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "3" } },
            [
              _c(
                "v-card",
                { staticClass: "pa-4" },
                [
                  _c("v-card-title", [_vm._v("Options")]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      label: "Page Type",
                      dense: "",
                      outlined: "",
                      items: _vm.options,
                    },
                    model: {
                      value: _vm.selectedOption,
                      callback: function ($$v) {
                        _vm.selectedOption = $$v
                      },
                      expression: "selectedOption",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      items: _vm.tierOptions,
                      label: "User Tier",
                      placeholder: "Select User Tier",
                      "item-text": "label",
                      "item-value": "value",
                      dense: "",
                      outlined: "",
                    },
                    model: {
                      value: _vm.userTierSelectedOption,
                      callback: function ($$v) {
                        _vm.userTierSelectedOption = $$v
                      },
                      expression: "userTierSelectedOption",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Input 1", dense: "", outlined: "" },
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Input 2", dense: "", outlined: "" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "9" } },
            [
              _c("v-text-field", {
                staticClass: "mb-2",
                attrs: {
                  rules: [(v) => !!v || "XML ID(s) is required"],
                  label: "XML ID(s)",
                  outlined: "",
                  dense: "",
                  "hide-details": "auto",
                },
                model: {
                  value: _vm.xmlIdsInput,
                  callback: function ($$v) {
                    _vm.xmlIdsInput = $$v
                  },
                  expression: "xmlIdsInput",
                },
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "mb-2",
                  attrs: {
                    block: _vm.isMobilePort,
                    color: "primary",
                    loading: _vm.isLoading,
                  },
                  on: { click: _vm.loadSection },
                },
                [_vm._v("\n                Load Section\n            ")]
              ),
              _vm._v(" "),
              _vm.hasError
                ? _c("div", { staticClass: "error--text" }, [
                    _c("p", [
                      _vm._v(
                        "There is an error while fetching data from the query. Please try again later."
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isNoDataFound
                ? _c("div", [
                    _c("p", [
                      _vm._v("No content found for query "),
                      _c("b", [_vm._v('"' + _vm._s(_vm.xmlIdsInput) + '"')]),
                    ]),
                  ])
                : _c(
                    "div",
                    [
                      _c("default-content-section-controller", {
                        attrs: { contentSections: _vm.contentSections },
                      }),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }